<ng-template #scimTokenModal>
  <div class="repositary-modal-show scim-token-dialog">
    <div class="modal-header">
      <h5 class="modal-title labelcolor" id="scim-token-title">SCIM bearer token</h5>
    </div>

    <div class="modal-body">
      <div class="scim-token-warning" role="alert">
        <strong>Copy this token now &mdash; it will not be shown again.</strong>
        <span>
          Deckorate does not keep a readable copy and there is no way to redisplay it.
          If it is lost, issue a new token &mdash; which revokes this one.
        </span>
      </div>

      @if (token) {
        <label for="scimTokenValue" class="labelcolor">Token</label>
        <div class="scim-copy-row">
          <input id="scimTokenValue"
            class="form-control input-air-primary scim-token-input"
            type="text"
            readonly
            autocomplete="off"
            spellcheck="false"
            [value]="token"
            (focus)="selectToken($event.target)">
          <button type="button" class="btn btn-secondary scim-copy-btn" (click)="copyToken()">
            <i class="fa fa-copy"></i> Copy
          </button>
        </div>
      }

      <!-- Written by the server for the admin; it already names the expiry date
           and what happens if the token lapses. -->
      @if (serverMessage) {
        <p class="scim-token-message">{{ serverMessage }}</p>
      }

      @if (expiresOn || rotationDays) {
        <dl class="scim-token-meta">
          @if (expiresOn) {
            <div>
              <dt>Expires</dt>
              <dd>{{ formatUtc(expiresOn) }}</dd>
            </div>
          }
          @if (rotationDays) {
            <div>
              <dt>Rotation window</dt>
              <dd>{{ rotationDays }} days</dd>
            </div>
          }
        </dl>
      }

      <div class="form-check mt-3 checkbox checkbox-solid-success">
        <input class="form-check-input" type="checkbox" id="scimTokenAck"
          [checked]="acknowledged"
          (change)="acknowledged = $any($event.target).checked">
        <label class="form-check-label labelcolor" for="scimTokenAck">
          I have copied the token and stored it securely
        </label>
      </div>

      <div class="button-container">
        <button type="button" class="btn btn-secondary me-2 mb-2 btn-save"
          [disabled]="!acknowledged"
          (click)="done()">
          DONE
        </button>
      </div>
    </div>
  </div>
</ng-template>
